
















































































































































































































































































































































































































































import {Component, Prop, Watch} from "vue-property-decorator";
import {FormModel} from "ant-design-vue";
import {CustomerStore} from "@/modules/customers/store";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {assignValueToForm} from "@/shared/services/helper/utils";
import {CommonStatus} from "@/enums/status";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import DistrictSelector from "@/modules/regions/DistrictSelector/index.vue";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
// import WardSelector from "@/modules/regions/WardSelector/index.vue";
import {PHONE_REGEX} from "@/shared/constant";
import {EmployeeType, FreightServiceType, PriceListType} from "@/enums/type";
import {FreightServiceStore} from "@/modules/freightservices/store";
import {FreightServiceParams} from "@/modules/freightservices/params";
import {Customer, FreightService} from "@/interfaces/entity";
import FreightServiceSelector from "@/shared/components/FreightServiceSelector/index.vue";
import PriceListSelector from "@/shared/components/PriceListSelector/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {createCustomerGuest} from "@/modules/customers/services";
import UploadMultipleImage from "@/shared/components/UploadMultipleImage/index.vue";
import {InsuranceFeeParams} from "@/modules/customers/params";
import InputCurrency from "@/shared/components/InputCurrency/index.vue";
import AInputCustom from "@/shared/components/CustomInputAnt/index.vue";
import {PriceListStore} from "@/modules/pricelists/store";
import {PriceListParams} from "@/modules/pricelists/params";
import {ShowWeightType} from "@/enums/type/showweight";

const dvkh = {
    freightServiceRowGuid: undefined,
    priceListId: undefined
};
const defaultWeightConversions = [
  { weight: "50", additionalWeightGram: 0 },
  { weight: "100", additionalWeightGram: 0 },
  { weight: "250", additionalWeightGram: 0 },
  { weight: "500", additionalWeightGram: 0 },
  { weight: "1000", additionalWeightGram: 0 },
  { weight: "1500", additionalWeightGram: 0 },
  { weight: "2000", additionalWeightGram: 0 },
  { weight: ">2000", additionalWeightGram: 0 }
]
const form = {
    username: "",
    password: undefined,
    rowGuid: "",
    customerCode: "",
    fullName: "",
    billAddress: "",
    identityCard: "",
    identityCardImages: "",
    identityCardImagesUrl: "",
    contact: "",
    phoneNumber: "",
    email: "",
    sender: "",
    senderPhone: "",
    address: "",
    // wardId: undefined,
    districtId: undefined,
    provinceId: undefined,
    contractCode: "",
    contractStartDate: undefined,
    contractEndDate: undefined,
    employeeRowGuid: undefined,
    postOfficeRowGuid: undefined,
    status: undefined,
    discount: undefined,
    priceListType: PriceListType.Default,
    serviceCustomers: [] as any,
    insuranceFee: {
        priceMark: undefined,
        freightAboveByPercent: undefined,
        minPrice: undefined
    },
    parent: {
    },
    parentRowGuid: "",
    showWeight: undefined,
    fuelRate: undefined,
    regionFarRate: undefined,
    taxFactor: undefined,
    enableWeightConversion: false,
    weightConversions: defaultWeightConversions
};

const formGuest = {
    customerCode: undefined,
    postOfficeRowGuid: undefined
};
@Component({
    name: "CustomerForm",
    components: {
        AInputCustom,
        InputCurrency,
        UploadMultipleImage,
        PriceListSelector,
        FreightServiceSelector,
        // WardSelector,
        EmployeeSelector,
        PostOfficeSelector, MillisecondDatePicker, DistrictSelector, ProvinceSelector, EnumSelector
    },
})
export default class extends mixins(CommonMixin) {
    @Prop()
    readonly id!: string;

    visibleGuest = false;
    CommonStatus = CommonStatus;
    ShowWeightType = ShowWeightType;
    PriceListType = PriceListType;
    FreightServiceType = FreightServiceType;
    EmployeeType = EmployeeType;
    private form = {...form, insuranceFee: new InsuranceFeeParams()};
    formGuest = {...formGuest};
    customer?: any = undefined;
    priceListLimit = 50;

    pathToUrl = (path: string) => `${process.env.VUE_APP_BASE_URL}upload/${path}`;

    private rules = {
        username: [{required: true, message: "Nhập tài khoản", trigger: "change"}],
        password: [{required: true, message: "Nhập mật khẩu", trigger: "change"}],
        customerCode: [{required: true, message: "Nhập mã khách hàng", trigger: "change"}],
        fullName: [{required: true, message: "Nhập họ tên", trigger: "change"}],
        billAddress: [{required: true, message: "Nhập địa chỉ thanh toán", trigger: "change"}],
        identityCard: [{required: true, message: "Nhập CCCD/CMND", trigger: "change"}],
        contact: [{required: true, message: "Nhập liên hệ", trigger: "change"}],
        phoneNumber: [
            {required: true, message: "Nhập số điện thoại", trigger: "change"},
            {pattern: new RegExp(PHONE_REGEX), message: "Số điện thoại không đúng định dạng", trigger: "change"}
        ],
        email: [{required: true, message: "Nhập email", trigger: "change"}],
        sender: [{required: false, message: "Nhập người gửi", trigger: "change"}],
        senderPhone: [
            {required: false, message: "Nhập số điện thoại người gửi", trigger: "change"},
            {pattern: PHONE_REGEX, message: "Số điện thoại không đúng định dạng", trigger: "change"}
        ],
        address: [{required: true, message: "Nhập địa chỉ", trigger: "change"}],
        // wardId: [{required: true, message: "Chọn phường/xã", trigger: "change"}],
        districtId: [{required: true, message: "Chọn phường/xã", trigger: "change"}],
        provinceId: [{required: true, message: "Chọn tỉnh/tp", trigger: "change"}],
        contractCode: [{required: true, message: "Nhập mã hợp đồng", trigger: "change"}],
        contractStartDate: [{required: true, message: "Chọn ngày bắt đầu hợp đồng", trigger: "change"}],
        contractEndDate: [{required: false, message: "Chọn ngày kết thúc hợp đồng", trigger: "change"}],
        employeeRowGuid: [{required: true, message: "Chọn nhân viên phục vụ", trigger: "change"}],
        postOfficeRowGuid: [{required: false, message: "Chọn bưu cục phục vụ", trigger: "change"}],
        rateFee: [{required: true, message: "Nhập tỉ lệ tính giá", trigger: "change"}],
        insuranceFee: {
            priceMark: [{required: true, message: "Nhập nấc tính cước", trigger: "change"}],
            minPrice: [{required: true, message: "Nhập cước tối thiểu", trigger: "change"}],
            freightAboveByPercent: [{required: true, message: "Nhập cước tính trên nấc", trigger: "change"}]
        },
        showWeight: [{required: true, message: "Chọn hiển thị trọng lượng"}]
    };

    rulesGuest = {
        customerCode: [{required: true, message: "Nhập mã khách hàng", trigger: "change"}],
    };

    private onSubmit() {
        (this.$refs.formCustomer as FormModel).validate(async valid => {
            if (!valid) return;
            const originServiceCustomers = this.form.serviceCustomers;
            if (this.form.priceListType === PriceListType.Default) {
                this.form.serviceCustomers = [];
            } else {
                this.form.serviceCustomers = this.form.serviceCustomers.filter((serviceCustomer: any) => serviceCustomer.priceListId);
            }
            try {
                this.id
                    ? await CustomerStore.updateCustomer(this.form)
                    : await CustomerStore.createCustomer(this.form);
                this.$notification.success({
                    message: "Thành công",
                    description: `${this.id ? 'Sửa' : 'Tạo'} khách hàng thành công`
                });
                this.$router.push({name: "listCustomers"});
            } catch (e) {
                this.form.serviceCustomers = originServiceCustomers;
                this.$notification.error({
                    message: "Thất bại",
                    description: `${e.response?.data?.message || `${this.id ? 'Sửa' : 'Tạo'} khách hàng thất bại`}`
                })
            }
        })
    }

    async created() {
        if (this.isAdmin) {
            this.rules = { ...this.rules, postOfficeRowGuid: [{required: true, message: "Chọn bưu cục phục vụ", trigger: "change"}], }
        }
        if (this.id) {
            this.rules.password = [{required: false} as any];
            try {
                this.customer = await CustomerStore.singleCustomer(this.id);
                this.form = assignValueToForm(this.form, { ...this.customer || {} });
                const freightServices = await this.listFreightServiceByPostOffice();
                if (this.form.priceListType === PriceListType.Default) {
                    this.form.serviceCustomers = this.mappingServiceCustomers([],freightServices);
                } else {
                    // this.customer?.serviceCustomers?.forEach((sc: any) => {
                    //     PriceListStore.addPriceList(sc.priceList)
                    // });
                    this.form.serviceCustomers = this.mappingServiceCustomers(this.customer?.serviceCustomers, freightServices)
                }

                if (!this.form.insuranceFee) {
                    this.form.insuranceFee = new InsuranceFeeParams()
                }
                if(this.form.weightConversions.length == 0){
                   this.form.weightConversions = defaultWeightConversions;
                }
                console.log(this.form);
            } catch (e) {
                console.log(e);
                this.$message.error(`${e.response?.data?.message || "Đã có lỗi xảy ra"}`)
            }
        } else {
            const freightServices = await this.listFreightServiceByPostOffice();
            this.form.serviceCustomers = this.mappingServiceCustomers([], freightServices);
        }

        if (this.isAdmin) {
            this.rulesGuest['postOfficeRowGuid'] = [{required: true, message: "Chọn bưu cục", trigger: "change"}]
        }
    }

    mappingServiceCustomers(serviceCustomers: Array<any>, services: Array<FreightService>) {
        console.log(services);
        return services.map((service: FreightService) => {
            const serviceCustomer = serviceCustomers?.find((sc: any) => sc.freightServiceRowGuid === service.rowGuid);
            return {
                freightServiceRowGuid: service.rowGuid as any,
                priceListId: serviceCustomer?.priceListId
            };
        });
    }

    submitGuest() {
        (this.$refs.formCustomerGuest as FormModel).validate(async valid => {
            if (!valid) return;
            try {
                await createCustomerGuest(this.formGuest);
                this.$message.success("Tạo khách lẻ thành công");
                this.visibleGuest = false;
            } catch (e) {
                this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi")
            }
        })
    }

    async listFreightServiceByPostOffice() {
        try {
            const params = {
                ...new FreightServiceParams(),
                type: FreightServiceType.NORMAL,
                limit: 200,
                status: CommonStatus.Active,
                postOfficeRowGuid: this.form.postOfficeRowGuid ? this.form.postOfficeRowGuid : this.currentPostOffice?.rowGuid
            };
            return await FreightServiceStore.listFreightService({ params });
        } catch (e) {
        }
    }

    async changePriceListType($evt: any) {
        const value = $evt.target.value;
        if (value === PriceListType.Option) {
            const freightServices = await this.listFreightServiceByPostOffice();
            this.form.serviceCustomers = this.mappingServiceCustomers(this.customer?.serviceCustomers, freightServices);
        }
    }

    @Watch("form.postOfficeRowGuid", { deep: true })
    async changePostOffice(val: any) {
        const freightServices = await this.listFreightServiceByPostOffice();
        this.form.serviceCustomers = this.mappingServiceCustomers(this.customer?.serviceCustomers, freightServices);
    }
}
